import { Pipe, PipeTransform } from '@angular/core';
import { ProjectJobPermitStatusSchema } from '@vmspdb/definitions';
import { AbstractEnumPipe } from './abstract-enum.pipe';

@Pipe({
  name: 'enumProjectJobPermitStatus',
  standalone: false,
})
export class EnumProjectJobPermitStatusPipe
  extends AbstractEnumPipe
  implements PipeTransform
{
  readonly enum = ProjectJobPermitStatusSchema;
}
